export default "__VITE_ASSET__b7XJcnCZ__"